export default function languageAvailableOnPage(language) {
  const nav = this.navigationLanguages;
  const tags = ['pre', 'div', 'span'];
  const selector = tags.map(tag => `${tag}[lang='${language}']`).join(',');
  const langExists = nav && nav.indexOf(language) >= 0;

  // Traverse the DOM as a last resort.
  return langExists || document.querySelectorAll(selector).length > 0;
}
